import React from 'react';
import { Card } from '../ui/Card';
import { MOCK_SITES } from '../../utils/multiSiteData';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
import { cn } from '../../utils/cn';
export function SLARiskLeaderboard() {
  const sortedSites = [...MOCK_SITES].sort((a, b) => {
    // Sort by risk score: (OverSLA * 3) + (Approaching * 1)
    const scoreA = a.trucksOverSLA * 3 + a.trucksApproachingSLA;
    const scoreB = b.trucksOverSLA * 3 + b.trucksApproachingSLA;
    return scoreB - scoreA;
  });
  return <Card className="h-full flex flex-col" noPadding data-id="element-246">
      <div className="p-4 border-b border-gray-800" data-id="element-247">
        <h3 className="font-semibold text-white" data-id="element-248">SLA Risk Leaderboard</h3>
      </div>
      <div className="overflow-auto" data-id="element-249">
        <table className="w-full text-sm text-left" data-id="element-250">
          <thead className="text-xs text-gray-500 bg-gray-900/50 uppercase" data-id="element-251">
            <tr data-id="element-252">
              <th className="px-4 py-3 font-medium" data-id="element-253">Rank</th>
              <th className="px-4 py-3 font-medium" data-id="element-254">Site</th>
              <th className="px-4 py-3 font-medium text-right" data-id="element-255">Over SLA</th>
              <th className="px-4 py-3 font-medium text-right" data-id="element-256">Avg Time</th>
              <th className="px-4 py-3 font-medium text-center" data-id="element-257">Trend</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800" data-id="element-258">
            {sortedSites.map((site, index) => <tr key={site.id} className="hover:bg-gray-800/30 transition-colors" data-id="element-259">
                <td className="px-4 py-3 text-gray-500" data-id="element-260">#{index + 1}</td>
                <td className="px-4 py-3 font-medium text-white" data-id="element-261">
                  {site.name}
                </td>
                <td className="px-4 py-3 text-right" data-id="element-262">
                  <span className={cn('px-2 py-0.5 rounded text-xs font-bold', site.trucksOverSLA > 0 ? 'bg-red-500/10 text-red-500' : 'text-gray-400')} data-id="element-263">
                    {site.trucksOverSLA}
                  </span>
                </td>
                <td className="px-4 py-3 text-right text-gray-300" data-id="element-264">
                  {Math.floor(site.avgTimeInside / 60)}h{' '}
                  {site.avgTimeInside % 60}m
                </td>
                <td className="px-4 py-3 text-center" data-id="element-265">
                  {site.trend === 'up' && <ArrowUpRight className="h-4 w-4 text-red-500 mx-auto" data-id="element-266" />}
                  {site.trend === 'down' && <ArrowDownRight className="h-4 w-4 text-emerald-500 mx-auto" data-id="element-267" />}
                  {site.trend === 'stable' && <Minus className="h-4 w-4 text-gray-600 mx-auto" data-id="element-268" />}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Card>;
}